import { render, staticRenderFns } from "./AdminTemplateListing.vue?vue&type=template&id=2dafbb86"
import script from "./AdminTemplateListing.vue?vue&type=script&lang=js"
export * from "./AdminTemplateListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports